import axios from "axios";
import { Base_URL } from "../url";

// Fetch all resources for dropdown (can reuse the same as TimeCardReport)
export const fetchAllResources = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters/${id}`);
    return response.data.map(resource => ({
      value: resource.resourceId,
      label: `${resource.resourceId} - ${resource.name}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

// Generate ticket time card report
export const generateTicketTimeCardReport = async (reportData) => {
  try {
    console.log("Report data to be sent:", reportData);
    
    const response = await axios.post(
      `${Base_URL}/TicketTimecard/GetTimecardsByResourceId`,
      {
        resourceId: reportData.ResourceCode,
        fromDate: reportData.FromDate || null,
        toDate: reportData.ToDate || null
      }
    );
    
    // Transform the API response to match our expected format
    const transformedData = response.data.data.map(item => ({
      TicketId: item.ticketId,
      ResourceId: item.resourceId,
      UserName: item.userName,
      Date: item.date.split('T')[0], // Extract just the date part
      ProjectCode: item.projectCode,
      Hours: item.hours,
      Task: item.tasks,
      Remarks: item.remarks,
      Location: item.location,
      Status: item.status,
      CreatedBy: item.createdBy
    }));
    
    return {
      ...response.data,
      data: transformedData
    };
  } catch (error) {
    throw error.response?.data || "Error generating ticket time card report!";
  }
};